<script setup>
import util from '@/util';
import { computed, ref } from 'vue';
import {
  CONTEXT,
  DEFAULT_LOGIN_TYPE,
  DEFAULT_REGISTER_TYPE,
  LOGIN_TYPE,
  REGISTRATION_TYPE,
} from '@/const';
import store from '@/store';
import ButtonGroup from '@/component/ButtonGroup.vue';

const jumpToEmailRegister = () =>
  util.jumpTo(
    `${CONTEXT.account}/register-mobile.html`,
    {
      defaultRegisterType: DEFAULT_REGISTER_TYPE.email,
    },
    ['defaultLoginType']
  );
const jumpToPasswordLogin = () =>
  util.jumpTo(
    `${CONTEXT.uniportal}/login-mobile.html`,
    {
      defaultLoginType: DEFAULT_LOGIN_TYPE.account,
    },
    ['defaultRegisterType']
  );

const registrationType = computed(() => store.state.appPolicy.registrationType);
const hasEmailRegister = computed(() => registrationType.value?.includes(REGISTRATION_TYPE.email));

const loginType = computed(() => store.state.appPolicy.loginType);
const hasAccountLogin = computed(() => loginType.value?.includes(LOGIN_TYPE.account));

const buttons = ref([
  {
    text: 'button.emailRegister',
    visible: hasEmailRegister,
    onClick: jumpToEmailRegister,
  },
  {
    text: 'button.passwordLogin',
    visible: hasAccountLogin,
    onClick: jumpToPasswordLogin,
  },
]);

const isOffCloud = computed(() => store.state.appPolicy.whiteTenantID);
const buttonText = computed(() => (isOffCloud.value ? 'button.w3Login' : 'button.employeeLogin'));
</script>

<template>
  <div class="py-4 px-5">
    <button-group class="mb-8" :buttons="buttons"></button-group>
    <div class="flex justify-center h-[30px]">
      <el-button
        v-if="hasAccountLogin"
        round
        class="employee-login"
        :class="{ 'custom-color': isOffCloud }"
        @click="jumpToPasswordLogin"
      >
        {{ $t(buttonText) }}
      </el-button>
    </div>
  </div>
</template>

<style scoped lang="less">
.employee-login {
  background: #f3f3f3 !important;
  border: none;
  color: #191919 !important;
  padding: 0 11px !important;

  &:active {
    color: #c8000b !important;
  }
}

.custom-color {
  color: #c8000b !important;
}
</style>
